// Store facts used across pages. Change them here, not in each page.
export const SITE_URL = "https://aerwear.us";
export const LEGAL_NAME = "AERWEAR LLC";
export const CONTACT_EMAIL = "aerwearbiz@gmail.com";
export const INSTAGRAM_HANDLE = "@aerwearusa";
export const INSTAGRAM_URL = "https://www.instagram.com/aerwearusa/";
export const TIKTOK_URL = "https://www.tiktok.com/@aerwearusa";

// Product page shipping line for made-to-order products (sold out or not).
export const SHIP_LINE = "Made to order. Ships in about 4 weeks, then 2 to 7 business days. Free US shipping.";
export const NOT_PROTECTIVE_LINE = "Fashion apparel, not protective gear.";

// Default share image: the site's own hero photo (1200x630 JPEG).
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;

// Jewelry and the Mystery Box are in stock, not made to order.
export const SAME_DAY_SHIP_LINE = "Ships same day, while stock lasts. Free US shipping.";

// Size guide is hidden until AERWEAR has a chart from the manufacturer.
// Set to true to bring back the product-page Size Guide section, its modal and the FAQ line.
export const SHOW_SIZE_GUIDE = false;

// Short trust lines near Add to Cart and in the cart. Keep them factual: no guarantees.
export const TRUST_LINE_MADE_TO_ORDER = "Made to order, ships in about 4 weeks. Free US shipping. Exchanges within 30 days.";
export const TRUST_LINE_IN_STOCK = "Ships same day while stock lasts. Free US shipping. Exchanges within 30 days.";
export const TRUST_LINE_CART = "Made-to-order pieces ship in about 4 weeks. Free US shipping. Exchanges within 30 days.";
